import { blogArticlePath, type MarketingLocale } from '../config/localeRoutes';
import type { AlternateLocalePaths } from '../components/SEO/SEOHead';

export function blogHreflangCode(language: string, market?: string | null): string {
  const lang = (language || 'fr').split('-')[0].toLowerCase();
  if (lang === 'fr' && String(market || '').toLowerCase() === 'be') {
    return 'fr-BE';
  }
  return lang;
}

type ArticleHreflangSlice = {
  language: string;
  slug: string;
  market?: string | null;
};

/** Alternates réciproques (+ x-default via SEOHead) pour un groupe de traductions publiées. */
export function buildBlogArticleAlternatePaths(
  current: ArticleHreflangSlice,
  translations: ArticleHreflangSlice[] = []
): AlternateLocalePaths | undefined {
  if (!current?.slug) return undefined;
  const siblings = [current, ...translations.filter((t) => t?.slug && t?.language)];
  const paths: Record<string, string> = {};
  for (const art of siblings) {
    const locale = art.language.split('-')[0].toLowerCase() as MarketingLocale;
    const code = blogHreflangCode(art.language, art.market);
    paths[code] = blogArticlePath(locale, art.slug);
  }
  if (Object.keys(paths).length <= 1) return undefined;
  return paths as AlternateLocalePaths;
}
